import React from 'react';
import InformativeText from "../../components/InformativeText/InformativeText";

const informativeTexts = props => {
  return (
    <div>
      {props.texts.map(text => (
        <InformativeText
          key={text.id}
          type={text.type}
          title={text.title}
          info={text.info}
          onClick={() => props.onClickEditButton(text)}
        />
      ))}
    </div>
  );
};

export default informativeTexts;
